export default __webpack_public_path__ + "a151fbb96015a57f1dad5f292a1752e3.png";